import React from "react";
import { Loader2, Film } from "lucide-react";
import { useSignedUrl } from "./api";

export const MediaPreview = ({ client, fid, tipo, className = "", controls = true }) => {
  const url = useSignedUrl(client, fid);
  if (!fid) {
    return (
      <div className={`bg-[#0A192F] flex items-center justify-center text-white/60 ${className}`}>
        <Film size={32} />
      </div>
    );
  }
  if (!url) {
    return (
      <div className={`bg-gray-100 flex items-center justify-center text-[#0A2463] ${className}`}>
        <Loader2 className="animate-spin" />
      </div>
    );
  }
  if (tipo === "video") {
    return <video src={url} controls={controls} playsInline preload="metadata" className={`bg-black ${className}`} data-testid="media-preview-video" />;
  }
  return <img src={url} alt="" className={`object-cover ${className}`} data-testid="media-preview-image" />;
};

export default MediaPreview;
